/* hg — animations discrètes au scroll (fade/slide) */
(function () {
  'use strict';

  function init() {
    var elements = document.querySelectorAll('[data-hg-reveal]');
    if (!elements.length) return;

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      elements.forEach(function (el) {
        el.classList.add('hg-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hg-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Ré-initialise dans l'éditeur de thème quand une section est rechargée
  document.addEventListener('shopify:section:load', init);
})();

/* hg — tracking des clics WhatsApp → Shopify Customer Events
   (relayé vers Meta par le pixel personnalisé "Meta - Contact WhatsApp") */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="wa.me"]');
    if (!link) return;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('hg_whatsapp_click', {
          url: link.href,
          page: window.location.pathname
        });
      }
    } catch (err) { /* silencieux */ }
  });
})();